import React from 'react';
import styles from './ProgressBar.module.css';

class ProgressBar extends React.Component {
  render() {
    const { value = 0, max = 100, label, showValue = false, size = 'md', color } = this.props;
    const pct = Math.min(100, Math.max(0, (value / max) * 100));

    return (
      <div className={styles.wrap}>
        {(label || showValue) && (
          <div className={styles.meta}>
            {label && <span className={styles.label}>{label}</span>}
            {showValue && <span className={styles.value}>{Math.round(pct)}%</span>}
          </div>
        )}
        <div className={[styles.track, styles[size]].join(' ')}>
          <div
            className={styles.fill}
            style={{ width: pct + '%', background: color || undefined }}
          />
        </div>
      </div>
    );
  }
}

export default ProgressBar;
